<template>
  <div class="home-page">
    <!-- Hero Section -->
    <div class="hero content">
      <h1 class="animated fadeInDown">Skillvolution</h1>
      <p class="animated fadeInUp">
        Exploring speedrunning, game development, and high-performance tech.
        This site has no real focus yet; I am just testing new tech, sharing experiences, and showcasing projects.
      </p>
    </div>

    <!-- Scroll Sections -->
    <div class="scroll-content">
      <section ref="section1" class="section animated slide-in-left" v-scroll>
        <img src="/assets/speedrunning.png" alt="Speedrunning" class="section-image" />
        <div class="text-content">
          <h2>Gaming Achievements</h2>
          <p>From world-record speedruns to competitive gaming, here’s my journey.</p>
          <router-link to="/speed-running" class="btn">View Speedrunning</router-link>
        </div>
      </section>

      <section ref="section2" class="section animated slide-in-right" v-scroll>
        <img src="/assets/robloxgamesIcon.png" alt="Game Development" class="section-image" />
        <div class="text-content">
          <h2>Game Development</h2>
          <p>Insights, tools, and projects related to game development.</p>
          <router-link to="/hobohat-games" class="btn">View Game Dev</router-link>
        </div>
      </section>

      <section ref="section3" class="section animated slide-in-left" v-scroll>
        <img src="/assets/pcbuild.png" alt="PC Build" class="section-image" />
        <div class="text-content">
          <h2>Tech Builds & Experiments</h2>
          <p>Custom PC builds, optimizations, and experiments with new technology.</p>
          <router-link to="/pc-build" class="btn">View PC Build</router-link>
        </div>
      </section>

      <section ref="section4" class="section animated slide-in-right" v-scroll>
        <img src="/assets/Software.png" alt="Projects" class="section-image" />
        <div class="text-content">
          <h2>Projects & Software</h2>
          <p>Personal software projects, automation, and useful tools.</p>
          <router-link to="/personal-projects" class="btn">View Projects</router-link>
        </div>
      </section>

      <section ref="section5" class="section animated slide-in-left" v-scroll>
        <img src="/assets/AboutMe.png" alt="About Me" class="section-image" />
        <div class="text-content">
          <h2>About Me</h2>
          <p>More about who I am, my background, and how I got into programming.</p>
          <router-link to="/about-me" class="btn">Learn More</router-link>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  export default {
    directives: {
      scroll: {
        mounted(el) {
          const handleScroll = () => {
            const position = el.getBoundingClientRect().top;
            const windowHeight = window.innerHeight;
            if (position < windowHeight * 0.85) {
              if (el.classList.contains("slide-in-left")) {
                el.classList.add("animate-slide-in-left");
              } else {
                el.classList.add("animate-slide-in-right");
              }
              el.classList.add("show");
            }
          };
          window.addEventListener("scroll", handleScroll);
          handleScroll(); // Check on load
        }
      }
    }
  };
</script>

<style scoped>
  /* Hero Section */
  .hero {
    text-align: center;
    padding: 80px 20px;
    color: white;
    background: #410051b3;
    backdrop-filter: blur(8px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    filter: drop-shadow(2px 4px 6px #00000033);
  }

  /* Scrollable Sections */
  .scroll-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 80px;
    padding: 50px 20px;
  }

  /* Section Layout */
  .section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    max-width: 900px;
    padding: 40px;
    background: rgb(65 0 81 / 70%);
    border-radius: 10px;
    text-align: left;
    opacity: 0;
    transform: translateY(50px);
    transition: all 0.8s ease-out;
    backdrop-filter: blur(8px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    flex-wrap: wrap;
  }

    /* Alternate Left & Right Layout */
    .section:nth-child(even) {
      flex-direction: row-reverse;
    }

  /* Image */
  .section-image {
    width: 150px;
    height: 150px;
    object-fit: contain;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.2);
    padding: 10px;
  }

  /* Text Content */
  .text-content {
    max-width: 500px;
  }

  /* Button */
  .btn {
    display: inline-block;
    padding: 10px 20px;
    margin-top: 10px;
    background: white;
    color: #333;
    font-weight: bold;
    text-decoration: none;
    border-radius: 5px;
    transition: background 0.3s ease;
  }

    .btn:hover {
      background: #ddd;
    }

  /* Slide-In Animations */
  .slide-in-left {
    transform: translateX(-50px);
  }

  .slide-in-right {
    transform: translateX(50px);
  }

  .animate-slide-in-left {
    transform: translateX(0);
    opacity: 1;
  }

  .animate-slide-in-right {
    transform: translateX(0);
    opacity: 1;
  }
</style>
